import api from './Api'

export const myReservationByToken = () => {
    return api.get<IMyReservation[]>(`/mobile/reservation/token`);
}
export const cancelReservation = (lectureId: number) => {
    return api.put(`/mobile/reservation/${lectureId}`)
}
export const updateReservationOnCheckIn = (reservation: IUpdateReservationForCheckIn) => {
    return api.put(`/reservation/wellness-lecture/update/web/v2`, reservation)
}
export const getAllWellnessLectureByYogaCenterIdAndMemberIdAndStartDateTimeBetweenAndIsDeleteFalse = (yogaCenterId: number, startDateTime: string, endDateTime: string) => {
    return api.get<IYogaLectureListByRangeDateAndYogaCenterIdGetResponse[]>(`/reservation/yoga-center/wellness-lecture/web/v2?yogaCenterId=${yogaCenterId}&startDateTime=${encodeURIComponent(startDateTime)}&endDateTime=${encodeURIComponent(endDateTime)}`);
}
export const getAllReservationByMemberIdAndReservationStatus = (reservationStatus?: string) => {
    return api.get<IReservationMyWebResponseV2[]>(`/reservation/my/web/v2?reservationStatus=${reservationStatus}`);
}
export const createOrUpdateReservationByMemberIdAndIssuedWellnessTicketIdAndWellnessLectureIdAndReservationStatus = (request: IReservationByMemberIdAndIssuedWellnessTicketIdAndWellnessLectureIdAndReservationStatusRequestV2) => {
    return api.post<string>(`/reservation/wellness-lecture/web/v2`, request);
}
export const cancelReservationByMemberIdAndReservationId = (reservationId: number) => {
    return api.put<string>(`/reservation/wellness-lecture/cancel/web/v2/${reservationId}`);
}

export const getMyReservedDateList = (yogaCenterId: number) => {
    return api.get<string[]>(`/mobile/my/reserved/date/v2?yogaCenterId=${yogaCenterId}`);
}

export const hasReservationToday = () => {
    return api.get<boolean>(`/mobile/reservation/today/exists`);
}